<template>
  <div>
    <span>
      <h1>Parcelamento Contrato: {{ numeroContrato }}</h1>
    </span>
    <v-flex>
      <v-layout row align-center>
        <v-flex grow pa-1 xs12 sm5 md4>
          <span>
            Quantidade de parcelas para todos os beneficiários
          </span>
        </v-flex>
        <v-flex grow pa-1 xs12 sm4 md1 align-self-center>
          <v-text-field
            v-model="qtdParcelasForAll"
            ref="qtdParcelasForAllField"
            single-line
            @input="value => quantidadeParcelas(value)"
          >
          </v-text-field>
        </v-flex>
        <v-flex grow pa-1>
          <v-btn @click="onClickAplicar" :disabled="qtdParcelasForAll <= 0">
            Aplicara a todos
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-data-table
      class="elevation-5 my-4 mx-1"
      no-data-text="Não há registros"
      rows-per-page-text="Linhas por página"
      :headers="headers"
      :items="selecionarBeneficiario"
      :loading="isLoading"
      :pagination.sync="pagination"
      :total-items="+numberOfElementsListFaturaPorBeneficiario"
      :rows-per-page-items="pageOptions"
    >
      <template v-slot:items="{ item }">
        <td>{{ item.codigoBeneficiario }}</td>
        <td>{{ item.nomeBeneficiario }}</td>
        <td>{{ `R$ ${item.valorTotal || "0"}` }}</td>
        <td>{{ `R$ ${item.valorParcelar || "0"}` }}</td>
        <td>
          <v-text-field
            :value="item.qtd"
            :rules="[
              required,
              maxQtdParcelas(
                item.valorMaximoPorParcela,
                item.qtd,
                item.valorParcelar,
                item.qtdMaximaPermitida
              )
            ]"
            @input="
              value => updateFieldQtdParcelas({ property: 'qtd', value, item })
            "
          />
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import { required, maxQtdParcelas } from "@/utils/validation-rules";

const portalStore = createNamespacedHelpers("portal");

export default {
  name: "SelecionarBeneficiario",
  props: {
    numeroContrato: String,
    selecionarBeneficiario: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      required,
      maxQtdParcelas,
      qtdParcelasForAll: "",
      isLoading: false,
      pageOptions: [5, 10, 25, { value: -1, text: "Todos" }],
      pagination: {
        page: 1,
        rowsPerPage: 5,
        sortBy: "numeroDocumento",
        descending: true
      },
      headers: [
        {
          text: "Código",
          value: "codigoBeneficiario",
          class: "px-2",
          width: 200
        },
        {
          text: "Nome",
          value: "nomeBeneficiario",
          sortable: false,
          class: "px-2"
        },
        {
          text: "Valor Total",
          value: "valorTotal",
          sortable: false,
          class: "px-2",
          width: 100
        },
        {
          text: "Valor a Parcelar",
          value: "valorParcelar",
          sortable: false,
          class: "px-2",
          width: 100
        },
        {
          text: "Quantidade Parcelas",
          value: "qtd",
          sortable: false,
          class: "px-2",
          width: 220
        }
      ]
    };
  },
  computed: {
    ...portalStore.mapState(["numberOfElementsListFaturaPorBeneficiario"])
  },
  methods: {
    ...portalStore.mapMutations([
      "updateFieldQtdParcelas",
      "updateField",
      "updateFieldQtdParcelasAllBeneficiario"
    ]),
    quantidadeParcelas(value) {
      const newValue = value
        .replace(/-/g, "")
        .replace(/\+/g, "")
        .replace(".", "")
        .replace(/\D/g, "");

      this.$refs.qtdParcelasForAllField.lazyValue = newValue;
      this.qtdParcelasForAll = newValue;
    },
    onClickAplicar() {
      this.updateFieldQtdParcelasAllBeneficiario({
        property: "qtd",
        value: this.qtdParcelasForAll
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.v-datatable td {
  padding: 0 8px !important;
}
</style>
